<template>
  <div>
    <div class="sr-only">
      <label for="allowDecimals">Allow Decimals</label>
    </div>
    <a-select
      v-model="allowDecimals"
      :options="allowDecimalsVOptions"
      id="allowDecimals"
      compress
      :disabled="disabled"
    ></a-select>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import {IDecimalPlaces} from "../interfaces/propertyInterfaces";
  import {InputFormatType} from "../../formability/form_builder/models/inputFormatType";
  import {IVOptionSetLocal} from "../interfaces/vSelectInterfaces";
  import disabledMixin from "../mixins/disabledMixin";

  export default Vue.extend({
    mixins: [disabledMixin],
    props: {
      model: {
        type: Object as () => IDecimalPlaces,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data: function () {
      return {
        allowDecimals: null,
      };
    },
    created() {
      this.allowDecimals = this.model.decimal_places !== null ? this.model.decimal_places === 2 : true;
    },
    computed: {
      allowDecimalsVOptions(): IVOptionSetLocal {
        let options = [
          {label: 'Allow Decimals', value: true},
          {label: 'Do Not Allow Decimals', value: false}
        ];
        return {options};
      },
    },
    watch: {
      allowDecimals(newVal): void {
        if (newVal && this.model.format_type === InputFormatType.Currency) {
          this.model.decimal_places = 2;
        } else if (this.model.format_type === InputFormatType.Currency) {
          this.model.decimal_places = 0;
        }
        this.model.defaultNumericValidation();
        this.allowDecimals = newVal;
      },
      'model.format_type': function (newVal, oldVal): void {
        if (newVal !== this.model.format_type) {
          if (newVal === InputFormatType.Numeric) {
            this.model.decimal_places = newVal === InputFormatType.Currency ? 2 : null;
            this.model.defaultNumericValidation();
          }
        }
      },
    }
  });
</script>
